"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.en = void 0;
exports.en = {
    'Confirm Email': 'Confirm Email',
    'Confirm Password': 'Confirm Password',
    'Email': 'Email',
    'Error button name': 'Start Over',
    'Error contact sales': 'We are unable to finish your request, please try again. If problem persists, contact sales@ff.com or (800) 228-7702 for immediate support.',
    'Error title': 'Oops',
    'First Name': 'First Name',
    'Last Name': 'Last Name',
    'Password': 'Password',
    'Phone Number': 'Phone Number',
    'Please enter a valid CN phone number': 'Please enter a valid CN phone number',
    'Please enter a valid email address': 'Please enter a valid email address',
    'Please enter a valid US phone number': 'Please enter a valid US phone number',
    'Required': 'Required',
};
